// src/components/card/card.tsx
import { tv } from "tailwind-variants";
import { jsx } from "react/jsx-runtime";
var cardStyles = tv({
  base: "flex flex-col rounded-2xl shadow-lg overflow-hidden",
  variants: {
    variant: {
      default: "bg-card text-card-fg border border-card-border "
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function Card({
  children,
  className,
  as,
  variant,
  ...rest
}) {
  const Component = as ?? "div";
  return /* @__PURE__ */ jsx(Component, { className: cardStyles({ className, variant }), ...rest, children });
}
export {
  Card,
  cardStyles
};
